import Typography from "@mui/material/Typography"

const ContactDepotMap = ({name, google_maps_embed}) => {
    return (
        <>
            <Typography color="primary" className="fw-bold mb-2" component="h6" variant="h5">{name}</Typography>
            <iframe className="w-100" src={google_maps_embed}  height="500" frameBorder="0"></iframe>

        </>
    )
}

export default ContactDepotMap;

